module.exports = "<span class=\"js-name member-text\">{{name}}</span>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/common/members/templates/listItem.hbs
// module id = 654
// module chunks = 0